var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 14.1663H4.66659C2.23325 14.1663 0.833252 12.7663 0.833252 10.333V5.66634C0.833252 3.23301 2.23325 1.83301 4.66659 1.83301H11.3333C13.7666 1.83301 15.1666 3.23301 15.1666 5.66634V10.333C15.1666 12.7663 13.7666 14.1663 11.3333 14.1663ZM4.66659 2.83301C2.75992 2.83301 1.83325 3.75967 1.83325 5.66634V10.333C1.83325 12.2397 2.75992 13.1663 4.66659 13.1663H11.3333C13.2399 13.1663 14.1666 12.2397 14.1666 10.333V5.66634C14.1666 3.75967 13.2399 2.83301 11.3333 2.83301H4.66659Z",
    fill: "#E7E9F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.5C6.62 10.5 5.5 9.38 5.5 8C5.5 6.62 6.62 5.5 8 5.5C9.38 5.5 10.5 6.62 10.5 8C10.5 9.38 9.38 10.5 8 10.5ZM8 6.5C7.17333 6.5 6.5 7.17333 6.5 8C6.5 8.82667 7.17333 9.5 8 9.5C8.82667 9.5 9.5 8.82667 9.5 8C9.5 7.17333 8.82667 6.5 8 6.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 5.16699H10.6667C10.3934 5.16699 10.1667 4.94033 10.1667 4.66699C10.1667 4.39366 10.3934 4.16699 10.6667 4.16699H12.6667C12.9401 4.16699 13.1667 4.39366 13.1667 4.66699C13.1667 4.94033 12.9401 5.16699 12.6667 5.16699Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33325 11.833H3.33325C3.05992 11.833 2.83325 11.6063 2.83325 11.333C2.83325 11.0597 3.05992 10.833 3.33325 10.833H5.33325C5.60659 10.833 5.83325 11.0597 5.83325 11.333C5.83325 11.6063 5.60659 11.833 5.33325 11.833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyOutline);
export default __webpack_public_path__ + "static/media/money-outline.d533629db41b450df397dbfc6992a3a9.svg";
export { ForwardRef as ReactComponent };